import { adminSearchShardCatalogDetailsGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminSearchShardCatalogDetailsDefaultReducers,
	adminSearchShardCatalogDetailsDefaultWatchers } from './default';

export const adminSearchShardCatalogDetailsReducers = combineReducers({
	default: adminSearchShardCatalogDetailsDefaultReducers,
	get: adminSearchShardCatalogDetailsGetSlice.asyncReducers
});

export const adminSearchShardCatalogDetailsWatchers = combineAllWatchers([
	adminSearchShardCatalogDetailsDefaultWatchers,
	adminSearchShardCatalogDetailsGetSlice.asyncWatchers
]);
